const MAGIC_COLORS = [
  ['#1E2A78', '#FF2E4C', '#FFE720', '#49DEB2'],
  ['#6F5F5E', '#FEC397', '#D28A7C', '#6D8C8E'],
  ['#FF4747', '#00BCB4', '#C4E86B', '#FFB547'],
  ['#B68FA2', '#586F77', '#ACBCB1', '#333B3E'],
  ['#8B776D', '#463C52', '#9D94BA', '#D1D5E8'],
  ['#FFCEBE', '#CD2C6C', '#5F023A', '#108292'],
  ['#7EC384', '#3F8756', '#45625D', '#6AA5A9'],
  ['#FEF3E2', '#EDCFC0', '#C3D3D6', '#D5DBE4'],
  ['#514945', '#894243', '#D55C5A', '#EBD4CC'],
  ['#ECEBEB', '#E6E5E5', '#D5D0D2', '#C5BEC4'],
  ['#FFEF38', '#F7A41A', '#275C7A', '#001446'],
  ['#99ABB9', '#B37B56', '#3D455C', '#60402B'],
  ['#AB0068', '#E00702', '#FF6C02', '#FEC106'],
  ['#DEA450', '#9B461F', '#6A1D2F', '#354C3C'],
  ['#001B48', '#02457A', '#018ABE', '#97CADB'],
  ['#CCABD8', '#8474A1', '#6EC6CA', '#08979D', '#055B5C'],
  ['#86E3CE', '#D0E6A5', '#FFDD94', '#FA897B', '#CCABD8'],
  ['#D9ECF2', '#F56A79', '#FF414D', '#1AA6B7', '#002D40'],
  ['#54C0CC', '#1F4F59', '#7EA00E', '#DCD964', '#213502'],
  ['#E25B45', '#FF8357', '#FAC172', '#89D5C9', '#ADC865'],
  ['#F5CEC7', '#E79796', '#FFC98B', '#FFB284', '#C6C09C'],
  ['#E2474B', '#2F3A56', '#406D96', '#A8D0DA', '#D8E8E8'],
  ['#AAC9CE', '#B6B4C2', '#C9BBC8', '#E5C1CD', '#F3DBCF'],
  ['#FCF5EF', '#FEA735', '#FE7235', '#00C3FF', '#0077FF'],
  ['#80BEAF', '#B3DDD1', '#D1DCE2', '#F5B994', '#EE9C6C'],
  ['#272537', '#606977', '#D1DCE2', '#E5D817', '#E3BF76'],
  ['#D2A9B0', '#E1C0D8', '#F1CFE5', '#A9A5A2', '#C8C6C9'],
  ['#FFFFFF', '#E7E7E7', '#D1D1D1', '#B6B6B6', '#9B9B9B'],
  ['#513485', '#7E5AB8', '#D79CD2', '#FDD51E', '#758B5C'],
  ['#999999', '#555555', '#FB6602', '#F6A705', '#AF948F'],
  ['#235D3A', '#397D54', '#73C088', '#A8E0B7', '#C8EAD1'],
  ['#478BA2', '#DE5B6D', '#E9765B', '#F2A490', '#B9D4DB'],
  ['#751102', '#A72F1D', '#C55241', '#E07464', '#F59E91'],
  ['#455054', '#308695', '#D45769', '#E69D45', '#D4CFC9'],
  ['#1B2727', '#3C5148', '#6B8E4E', '#B2C5B2', '#D5DDDF'],
  ['#321E25', '#663845', '#8B4E5E', '#C06378', '#E894A7'],
  ['#07585C', '#3E9022', '#DE076F', '#491545', '#491515'],
  ['#5D0D02', '#A61804', '#FC0000', '#FF4646', '#FF7A7A'],
  ['#5D7599', '#ABB6C8', '#DADADA', '#F7F0C6', '#C2C4B6'],
  ['#7E9680', '#79616F', '#AE6378', '#D87F81', '#EAB595', '#EAD7BA', '#5D7599', '#ABB6C8', '#9FCAA3', '#E78764', '#AE6378', '#E1D839'],
  ['#C6A477', '#ECD59F', '#D3E7EE', '#ABD1DC', '#7097A8'],
  ['#391E22', '#56373C', '#9F807D', '#D0B0B1', '#E6D1D8'],
  ['#117C6F', '#289C8E', '#2FC4B2', '#8DE5DB', '#B2F0E8'],
  ['#131B2E', '#505D7D', '#5497C7', '#B5561C', '#E79315'],
  ['#7E0306', '#D53E0F', '#FA8743', '#FCAF67', '#FFDECD'],
  ['#3B5284', '#5BA8A0', '#CBE54E', '#94B447', '#5D6E1E'],
  ['#DDC1C6', '#C5A0A7', '#906E74', '#704C52', '#533637'],
  ['#332B3A', '#2B2C40', '#3A4D8F', '#6A95CC', '#A1CAFF'],
  ['#C73866', '#FE676E', '#FD8F52', '#FFBD71', '#FFDCA2'],
  ['#3D1242', '#5C1864', '#782C81', '#9737A2', '#BF4DCC', '#DC67E9', '#ED86F8', '#F49AFD', '#F6ABFD', '#FAD0FE'],
  ['#0162A7', '#3E9FB2', '#FEB500', '#CD9489', '#B41D6C'],
  ['#DA2864', '#EC6091', '#F2A7BE', '#9AE1E2', '#16A5A3'],
  ['#000000', '#262626', '#424242', '#595959', '#777777'],
  ['#264D59', '#43978D', '#F9E07F', '#F9AD6A', '#D46C4E'],
  ['#372B2F', '#B29671', '#BFAC36', '#2E8477', '#342B56'],
  ['#522157', '#8B4C70', '#C2649A', '#E4C7B7', '#E4DFD9'],
  ['#0A3D64', '#DDB0A7', '#EAAD5A', '#A8B293', '#DF8053'],
  ['#015C92', '#2D82B5', '#FB6602', '#88CDF6', '#BCE6FF'],
  ['#B83051', '#5B697A', '#C8925A', '#5D8086', '#58705A'],
  ['#FF0000', '#FF3F3F', '#FF5858', '#FF7272', '#F98282', '#FF8C8C', '#FFB6B6', '#FFC6C6', '#FFD6D6', '#FFE5E5', '#FFF2F2'],
  ['#E8DBCB', '#E2B9B3', '#5F3A42', '#839973', '#36374B'],
  ['#C6CBD1', '#A6A2A1', '#41384E', '#725A7A', '#B8AAC3'],
  ['#EEE7DF', '#DBCBBE', '#B0988E', '#4D8581', '#ABDED7'],
  ['#FF7B89', '#8A5082', '#6F5F90', '#758EB7', '#A5CAD2'],
  ['#A7BEE1', '#D3C68B', '#D3C1B1', '#B66D93', '#8A9F8E'],
  ['#E97311', '#F28F14', '#F3AC19', '#EDC814', '#E8DC0C'],
  ['#947839', '#751102', '#E78332', '#EFB20C', '#326569'],
  ['#FFFFFF', '#ECD4EA', '#A987A8', '#693B69', '#511F52'],
  ['#5AA7A7', '#96D7C6', '#BAC94A', '#E2D36B', '#6C8CBF'],
  ['#071E55', '#143074', '#2046A1', '#3963C8', '#3868D9', '#4476EB', '#618EF8', '#7CA3FF', '#90B1FF', '#A7C1FF', '#BFD2FF'],
  ['#ECB865', '#255F63', '#695356', '#DB7B65', '#FBC9BE'],
  ['#FAB10C', '#F4B076', '#27A2BB', '#D6D6D6', '#85BFCD'],
  ['#CC7952', '#943D2C', '#474344', '#E5BD77', '#DFD0BB'],
  ['#85CBCC', '#A8DEE0', '#F9E2AE', '#FBC78D', '#A7D676'],
  ['#31405F', '#094152', '#194F6B', '#C995A2', '#BFC6CC'],
  ['#DF825F', '#F8956F', '#DFB15B', '#4D446F', '#706695'],
  ['#041E1B', '#053630', '#23321D', '#D59F35', '#DD855F'],
  ['#33539E', '#7FACD6', '#BFB8DA', '#E8B7D4', '#A5678E'],
  ['#B8A79F', '#555F57', '#774068', '#D76A63', '#E9CD84'],
  ['#60EFDB', '#BEF2E5', '#C5E7F1', '#79CEED', '#6F89A2'],
  ['#737955', '#C8C6B1', '#53242C', '#B2393E', '#CF514A'],
  ['#222830', '#B0B5B5', '#ECBD8B', '#F4841A', '#004C56'],
  ['#E2D3CD', '#E3DAD5', '#E6CDB5', '#F7D8B5', '#D0C8B6'],
  ['#856968', '#553A59', '#B8535A', '#E9B57C', '#E8DDC9'],
  ['#050831', '#133072', '#415BA7', '#F946AB', '#E1035A'],
  ['#2D0C03', '#98514B', '#F9B785', '#F4F6EB', '#FF1A49'],
  ['#D6A3DC', '#F7DB70', '#EABEBF', '#75CCE8', '#A5DEE5'],
  ['#FC6B05', '#FFB62B', '#65B017', '#99D8DB', '#9BB7BB'],
  ['#870040', '#CE4A87', '#FF82BF', '#F8BAD6', '#DBC2A4'],
  ['#537C8E', '#2DBDBD', '#EFF1E4', '#CEAE7F', '#865840'],
  ['#240C00', '#F18500', '#FFCA01', '#648D00', '#005200'],
  ['#47CACC', '#63BCC9', '#CDB3D4', '#E7B7C8', '#FFBE88'],
  ['#1C2135', '#5A6794', '#8794C0', '#E7E9EE', '#D8CDB0'],
  ['#632A00', '#EE932A', '#74C58D', '#549227', '#012C00'],
  ['#041B2D', '#004E9A', '#428CD4', '#FF9CDA', '#EA4492'],
  ['#FFB15C', '#469B72', '#1D152D', '#F0EEEF', '#F0C9CE'],
  ['#35BBCA', '#0191B4', '#F8D90F', '#D3DD18', '#FE7A15'],
  ['#9BBCCD', '#5D9700', '#D2374A', '#A70618', '#0D0F11'],
  ['#7E1037', '#C14E76', '#DF7DA6', '#F7B2CF', '#FFE4E1'],
  ['#4A707A', '#7697A0', '#94B0B7', '#C2C8C5', '#DDDDDA'],
  ['#EFA078', '#F9DDD0', '#F7F2EF', '#C0B7B8', '#A29193'],
  ['#6AAB9C', '#FA9284', '#E06C78', '#5874DC', '#384E78'],
  ['#7C5EFD', '#99EEEE', '#F7BC23', '#FF4848', '#303030'],
  ['#2C6975', '#68B2A0', '#CDE0C9', '#E0ECDE', '#FFFFFF'],
  ['#031B88', '#6096FD', '#AAB6FB', '#FB7B8E', '#FAA7B8'],
  ['#F2D06C', '#DA5A41', '#C02642', '#4F1E31', '#597C80'],
  ['#FBEEE6', '#FFE5D8', '#FFCAD4', '#F3ABB6', '#9F8189'],
  ['#492D41', '#6E4C6C', '#7F678E', '#9F9DBA', '#8E96A2'],
  ['#205072', '#329D9C', '#56C596', '#7BE495', '#CFF4D2'],
  ['#567DB0', '#344C6C', '#EC505D', '#F6EFED', '#83A4B6'],
  ['#0B0742', '#120C6E', '#5E72EB', '#FF9190', '#FDC094'],
  ['#413E7D', '#6E6DD0', '#FFF074', '#27B6BB', '#F88973'],
  ['#7BD5F5', '#787FF6', '#4ADEDE', '#1CA7EC', '#1F2F98'],
  ['#E8A49C', '#3C4CAD', '#240E8B', '#F04393', '#F9C449'],
  ['#DC8665', '#138086', '#534666', '#CD7672', '#EEB462'],
  ['#1E5361', '#F7CD5E', '#F97C08', '#6A2D00', '#A46A31'],
  ['#1039A0', '#0146F2', '#FFD664', '#FF1684', '#FFFFFF'],
  ['#720632', '#970A44', '#F6F4EB', '#1C4668', '#09263D'],
  ['#1C295D', '#264393', '#ABDCFC', '#F8DB7A', '#FFFFFF'],
  ['#182F30', '#8B9FA5', '#84B7CA', '#D0C146', '#9A8A79'],
  ['#FDB3CA', '#A9DFE2', '#5C6898', '#D1D5FA', '#FFFFFF'],
  ['#F4F0ED', '#F87556', '#81DDE6', '#57D0DB', '#2AB9C6'],
  ['#BCA285', '#E5B88B', '#BFC7CA', '#5E565A', '#E4C6CD'],
  ['#7A7E8C', '#BFCAF7', '#AF49AB', '#DCD346', '#DF3F46'],
  ['#5F2C3D', '#C27573', '#DDD5CB', '#F0ECE7', '#FFFFFF'],
  ['#9DC3E2', '#9DD2D8', '#FADCE4', '#FFB5CC', '#E2B9DB'],
  ['#E1D4DD', '#CCABD8', '#8474A1', '#089896', '#035B5C'],
  ['#F90202', '#F97F02', '#FFED00', '#5DFF00', '#00DDFF'],
  ['#8DAAA6', '#D5D7CC', '#F6D5B6', '#E9AE8C', '#FF9376'],
  ['#FFDD00', '#FFED00', '#FFF57F', '#FFF8A7', '#FFF7C8'],
  ['#F0E1DC', '#D9C0B9', '#926F89', '#5670A3', '#181D45'],
  ['#AB7948', '#CAA679', '#DEC9A8', '#B3CFC4', '#7DAAA7'],
  ['#BC4B00', '#DE8A0C', '#FEC904', '#598901', '#2D5A00'],
  ['#FFE2A0', '#C9FFA0', '#A0ECFF', '#A0C0FF', '#FFA0A0'],
  ['#B0C9E5', '#F5D488', '#F5B488', '#DC8BA3', '#BE8BDC'],
  ['#2D4B65', '#4378A2', '#AF4474', '#F4C434', '#9ACC8F'],
  ['#01689C', '#007F9F', '#1EB0BB', '#009B6A', '#0FA982'],
  ['#326199', '#4FB1A1', '#FCC055', '#EB8D50', '#DF6E5B'],
  ['#43045F', '#4E0362', '#C63264', '#FF9799', '#FFBAAB'],
  ['#525358', '#818E85', '#ADB8B2', '#C9D6CF', '#D997BB'],
  ['#402131', '#763C4B', '#EA6461', '#FCA476', '#FBCD6D'],
  ['#334666', '#7484A6', '#9DABC8', '#E8B7C3', '#C99FA9'],
  ['#125488', '#2A93D5', '#37CAEC', '#3DD9D6', '#ADD9D8'],
  ['#231F20', '#426C95', '#F15F4E', '#F4D550', '#FAF7D8'],
  ['#4F4AA9', '#968FD8', '#FFEE9F', '#8CE8C7', '#F98278'],
  ['#F392A3', '#85D0CC', '#FDD194', '#94D0FD', '#C9CBA5'],
  ['#399448', '#39948E', '#B2E8F7', '#FFDAE6', '#DF7599'],
  ['#CE6A6B', '#EBACA2', '#FFDFCB', '#326280', '#212E53'],
  ['#F89554', '#56867E', '#A8A0A5', '#F2E2DD', '#DC9A80'],
  ['#423C6D', '#7A839E', '#94B5C2', '#EADCC1', '#FEF5D8'],
  ['#93A8B0', '#E6D4A2', '#C6D6B0', '#848C57', '#555B32'],
  ['#850009', '#BA4C49', '#E0907A', '#F7E8E7', '#FDD8A3'],
  ['#0F1E32', '#5886AF', '#E1F5FF', '#EAC77D', '#B47B44'],
  ['#212730', '#4B5057', '#787D85', '#E6E6E6', '#01ACB4'],
  ['#F2C6F2', '#B561BF', '#A6D1FF', '#3988E1', '#5B9252'],
  ['#C8BD00', '#A44F6E', '#3F1A34', '#005B95', '#002644'],
  ['#F8EC6C', '#EF895D', '#B73A5D', '#6A2B6F', '#3AA6B7'],
  ['#2960DE', '#F5E53A', '#96B2FB', '#FFD3D4', '#DB5629'],
  ['#FC9A01', '#EE8300', '#3B2318', '#CC9C75', '#E5BEA1'],
  ['#233A48', '#436E67', '#6C9585', '#BED0A6', '#E5E3CE'],
  ['#787785', '#DEB7B8', '#F2D5D7', '#FDEBEB', '#F6F2F1'],
  ['#EB6763', '#D83236', '#9599A3', '#6E7181', '#15173F'],
  ['#F3AA99', '#FFB47B', '#FE7C5E', '#745184', '#331B4D'],
  ['#8ECAE6', '#209EBB', '#023047', '#FFB701', '#FC8500'],
  ['#A637A0', '#933FA1', '#FFCF04', '#DF665D', '#9FAEC3'],
  ['#D8E8E9', '#A8D0DA', '#406D95', '#2F3A57', '#E2474C'],
  ['#71C290', '#097852', '#3B2D3F', '#BD5FB7', '#F69651'],
  ['#FBEA6B', '#6E5F68', '#DDC8EC', '#EEDBF1', '#F8E9F4'],
  ['#454544', '#D89864', '#FCCD8D', '#F0F0E5', '#F0F0F0'],
  ['#EEF0F1', '#E2E0DF', '#D8C9AE', '#D2D689', '#A19E50'],
  ['#DEDEE0', '#BFBDB9', '#CBC3BA', '#757071', '#36363D'],
  ['#E1E6E6', '#C4DAE6', '#92C8E0', '#67ABD6', '#C3B0D6'],
  ['#BFD5DB', '#42615B', '#222E2B', '#D66251', '#EB9E86'],
  ['#272B32', '#62647B', '#EE6666', '#EB8181', '#F29B9B'],
  ['#77A7DF', '#3D6DD1', '#45A56A', '#327962', '#D94D65'],
  ['#91245B', '#4E363D', '#FB6583', '#E8113E', '#85A98E'],
  ['#FC122C', '#C80058', '#821963', '#3D2250', '#121525'],
  ['#FAFA6E', '#86D780', '#23AA8F', '#007882', '#2A4858'],
  ['#E68D61', '#F4E1C6', '#5CC2B7', '#F4A9C9', '#D1466C'],
  ['#EFF1FE', '#BCC2D7', '#8895B1', '#546C8C', '#194568'],
  ['#9FBCC2', '#AFC7BF', '#C7CFC0', '#DDD6CA', '#EEDFDA'],
  ['#B4BABE', '#8A8E9C', '#706073', '#593440', '#371005'],
  ['#373442', '#1D5562', '#FFE6D5', '#FFC48F', '#ED4B56'],
  ['#E68FE6', '#FF7E9E', '#FC8E56', '#C0A92D', '#61BC52']
];

export default MAGIC_COLORS;


// WEBPACK FOOTER //
// ./src/components/SmartPages/magicColors.js